import { render, staticRenderFns } from "./TaskColumn.vue?vue&type=template&id=6ad80cf3&scoped=true&"
import script from "./TaskColumn.vue?vue&type=script&lang=js&"
export * from "./TaskColumn.vue?vue&type=script&lang=js&"
import style0 from "./TaskColumn.vue?vue&type=style&index=0&id=6ad80cf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad80cf3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VIcon,VList,VListItem,VMenu,VSheet,VVirtualScroll})
